export class ActionLogRequestEntity {
  search?: string;
  name?: string;
  code?: string;
  path?: string;
  type?: string;
  status?: string;
  input?: string;
  output?: string;
  user?: string;
  fromDate?: string;
  toDate?: string;
  created?: Array<Record<string, unknown>>;
  isNeedDate?: boolean;
  page?: number;
  limit?: number;

  constructor(data?: Partial<ActionLogRequestEntity>) {
    this.search = data?.search;
    this.name = data?.name;
    this.code = data?.code;
    this.path = data?.path;
    this.type = data?.type;
    this.status = data?.status;
    this.input = data?.input;
    this.output = data?.output;
    this.user = data?.user;
    this.page = data?.page;
    this.limit = data?.limit;
    this.isNeedDate = data?.isNeedDate;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.created = data?.created;
  }
}
